import React, { Component } from 'react'
import { Card, Button, Table, Modal, message } from 'antd'

import { connect } from 'react-redux'
import { req_list_role, req_add_role, req_update_role } from '../../api'
import { act_logout } from '../../redux/actions'

import RoleAdd from './role-add'
import RoleAuthModify from './role-auth-modify'

import { formateDateDb } from '../../utils/dateUtil'
import { PAGE_SIZE } from '../../utils/contrains'
import './role.less'

class Role extends Component {

    // 基礎通用參數 //////////////////////////////////////////////  

    state = {
        roles: [], //all role
        role: {}, // selected role
        isShowAdd: false,
        isShowAuth: false
    }

    form_edit_modal = React.createRef()
    UNSAFE_componentWillMount() {
        this.init_columns()
    }

    componentDidMount() {
        this.api_list_role()
    }

    // 遠端數據處理 //////////////////////////////////////////////

    api_list_role = async () => {
        const token = this.props.user.token
        const result = await req_list_role(token)
        if (result.total > 0) {
            const roles = result.data
            this.setState({ roles })
        }
    }

    api_add_role = async (role) => {
        const token = this.props.user.token
        const result = await req_add_role(role, token)
        // 3.根據結果提示/更新列表
        if (result.status === 'success') {
            // 3.1 結果提示
            message.success('增加角色成功')
            this.addform.current.resetFields()
            this.setState({ isShowAdd: false })
            // 3.2 更新列表
            const new_role = result.data

            // 若在既有的數據上增刪改，採用以下方式
            this.setState(state => ({
                roles: [...this.state.roles, new_role]
            }))
        } else {
            message.success('增加角色失敗')
        }

        //console.log(result);
    }

    api_edit_role = async (role) => {
        const token = this.props.user.token
        const result = await req_update_role(role, token)
        // 3.根據結果提示/更新列表
        if (result.status === 'success') {
            // 3.1 結果提示
            message.success('更新角色權限成功')
            // 如果當前更新是自己的角色強制退出
            if (role.roleCode === this.props.user.role) {
                this.props.act_logout()
                message.success('更新自己的角色權限，強制登出')
                this.props.history.replace('/login')
            } else {
                this.setState({
                    isShowAuth: false,
                    roles: [...this.state.roles]
                })
            }
        } else {
            message.success('更新角色權限失敗')
        }
    }

    // 數據配置設定 ////////////////////////////////////////////// 

    init_columns = () => {
        this.columns = [
            {
                title: '角色名稱',
                dataIndex: 'roleName',
                fixed: 'left',
                width: 60,
            },
            {
                title: '角色代碼',
                dataIndex: 'roleCode',
                width: 50,
            },

            {
                title: '建立時間',
                dataIndex: 'recordCreateTimeStamp',
                render: (recordCreateTimeStamp) => formateDateDb(recordCreateTimeStamp),
                width: 80,
            },
            {
                title: '授權者帳號',
                dataIndex: 'authorizerCode',
                width: 80,
            },
            {
                title: '授權時間',
                dataIndex: 'recordAuthorizedTimeStarmp',
                render: (recordAuthorizedTimeStarmp) => formateDateDb(recordAuthorizedTimeStarmp),
                width: 80,
            }
        ]

    }

    event_table_row = (role) => {
        return {
            onClick: event => {
                this.setState({ role })
            }, // click row
        };
    }

    // 操作互動處理 //////////////////////////////////////////////

    handle_process_add_role = () => {
        this.addform.current.validateFields().then(values => {
            // 1.收集輸入數據
            const { roleName } = values
            const authorizerCode = this.props.user.userCode
            const role = {
                roleName: roleName,
                authorizerCode: authorizerCode
            }
            // 2.寫入後端
            this.api_add_role(role)
        }).catch(error => {
            console.log(error.errorFields);
        });
    }

    handle_process_edit_roleAuth = () => {
        const role = this.state.role
        const menus = this.form_edit_modal.current.output_menus()
        role.authorizerCode = this.props.user.userCode

        role.menus = menus.reduce((preValues, currentValue) => {
            if (currentValue.includes('/')) {
                preValues.push({ roleCode: role.roleCode, linkUrl: currentValue })
            }
            return preValues
        }, [])

        role.condition = 'CODE'
        //console.log('role', role)
        this.api_edit_role(role)
    }

    /////////////////////////////////////////////////////////////

    render() {
        const { roles, role, isShowAdd, isShowAuth } = this.state
        const title = (
            <span>
                <Button type="primary" onClick={() => this.setState({ isShowAdd: true })} >建立角色</Button>&nbsp;&nbsp;
                <Button type="primary" disabled={!role.uid} onClick={() => this.setState({ isShowAuth: true })} >設定權限</Button>
            </span>
        )
        return (
            <Card title={title}>
                <Table
                    bordered
                    rowKey='uid'
                    dataSource={roles}
                    columns={this.columns}
                    pagination={{ defaultPageSize: PAGE_SIZE }}
                    rowSelection={{
                        type: 'radio',
                        selectedRowKeys: [role.uid],
                        rowSelection: (role) => {
                            // 解決 radio 點不到問題 
                            this.setState({ role })
                        }
                    }}
                    onRow={this.event_table_row}
                    scroll={{ x: 800 }}
                    sticky
                />

                <Modal
                    destroyOnClose={true}
                    title="增加角色"
                    visible={isShowAdd}
                    onOk={this.handle_process_add_role}
                    onCancel={() => {
                        this.setState({ isShowAdd: false })
                    }}
                >
                    <RoleAdd
                        setForm={(form) => this.addform = form}
                    />
                </Modal>

                <Modal
                    destroyOnClose={true}
                    title="設定角色權限"
                    visible={isShowAuth}
                    onOk={this.handle_process_edit_roleAuth}
                    onCancel={() => {
                        this.setState({ isShowAuth: false })
                    }}
                >
                    <RoleAuthModify role={role} ref={this.form_edit_modal} />
                </Modal>
            </Card>
        )
    }
}

export default connect(
    state => ({ user: state.user }),
    { act_logout }
)(Role)